/**
 * Quick setup — "Smart defaults" aside (plan 6.C). Wide breakpoint only; read-only summary + Edit jumps.
 */

import React from "react";
import Icon from "../../ui/Icon";
import { E, SECTIONS } from "../../state/constants";
import {
  durationLongLabel,
  formatLabel,
  humanizeMinutes,
  isGroup,
  isPaid,
  paymentTimingLabel,
  priceLabel,
} from "../../state/selectors";
import { useBuilder } from "../../state/builderContext";

const calendarName = (row) => {
  if (!row) return "";
  try {
    const meta = typeof row.meta_data === "string" ? JSON.parse(row.meta_data || "{}") : row.meta_data || {};
    return meta.email || meta.name || "";
  } catch (e) {
    return "";
  }
};

const SmartDefaults = () => {
  const { state, focusBlock, goToSection } = useBuilder();
  const paid = isPaid(state);
  const calendars = state.lookups.connectedCalendars || [];
  const firstCalendar = calendarName(calendars[0]);
  const notice = humanizeMinutes(state.availability.min_scheduling_notice_minutes);

  return (
    <aside className="eb-smart-defaults">
      <div className="eb-defaults-head">
        <span>
          <Icon name="sparkle" size={16} />
        </span>
        <h2>Smart defaults</h2>
        <p>Already configured for you</p>
      </div>
      <ul className="eb-editable-defaults">
        {paid ? (
          <li className="paid-default">
            <span className="eb-default-check">
              <Icon name="card" size={14} />
            </span>
            <span>
              <strong>{priceLabel(state) || "Price not set"}</strong>
              <small>{paymentTimingLabel(state)}</small>
            </span>
            <button type="button" onClick={() => focusBlock("payment-setting", SECTIONS.QUICK)}>
              Edit
            </button>
          </li>
        ) : null}
        <li>
          <span className="eb-default-check">
            <Icon name="clock" size={14} />
          </span>
          <span>
            <strong>Duration</strong>
            <small>{durationLongLabel(state)}</small>
          </span>
          <button type="button" onClick={() => focusBlock("duration-setting", SECTIONS.QUICK)}>
            Edit
          </button>
        </li>
        <li>
          <span className="eb-default-check">
            <Icon name="users" size={14} />
          </span>
          <span>
            <strong>Booking format</strong>
            <small>{isGroup(state) ? `Group \u00B7 ${state.type.no_of_attendies || 0} invitees` : formatLabel(state)}</small>
          </span>
          <button type="button" onClick={() => focusBlock("booking-format-setting", SECTIONS.QUICK)}>
            Edit
          </button>
        </li>
        <li>
          <span className="eb-default-check color-preview" style={{ background: state.details.event_color }} />
          <span>
            <strong>Event color</strong>
            <small>Used in calendar and event list</small>
          </span>
          <button type="button" onClick={() => focusBlock("event-color-setting", SECTIONS.QUICK)}>
            Edit
          </button>
        </li>
        <li>
          <Icon name="check" size={16} />
          <span>
            <strong>Calendar conflicts</strong>
            <small>{firstCalendar ? `Checked on ${firstCalendar}` : "No calendar connected"}</small>
          </span>
        </li>
        <li>
          <Icon name="check" size={16} />
          <span>
            <strong>Minimum notice</strong>
            <small>{notice ? `${notice} before booking` : "No minimum"}</small>
          </span>
        </li>
        <li>
          <Icon name="check" size={16} />
          <span>
            <strong>Email reminder</strong>
            <small>{state.advanced.email_reminder_status === E ? "On \u00B7 from your notification settings" : "Off"}</small>
          </span>
        </li>
      </ul>
      <button type="button" onClick={() => goToSection(SECTIONS.AVAILABILITY)}>
        Review additional settings <Icon name="chevron" size={15} />
      </button>
    </aside>
  );
};

export default SmartDefaults;
